import { create } from 'zustand'

/**
 * The bearer the console sends the engine: a Directus access token for a
 * logged-in operator on this deploy line, or the shared secret for machine and
 * dev use. `App.tsx` shows the login screen while it is null.
 */
interface AuthState {
  token: string | null
  setToken: (token: string | null) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  token: typeof localStorage !== 'undefined' ? localStorage.getItem('ludus.token') : null,
  setToken: (token) => {
    if (token) localStorage.setItem('ludus.token', token)
    else localStorage.removeItem('ludus.token')
    set({ token })
  },
  logout: () => {
    localStorage.removeItem('ludus.token')
    set({ token: null })
  },
}))
